// TODO: Fix React 19 compiler lint errors. See https://react.dev/learn/react-compiler
/* eslint-disable react-hooks/static-components */
import React from 'react';
import Container from '@ui/Container/Container';
import { TemplatesQuery } from 'graphql/generated/types.autogenerated';
import NavBar from './Navbar';
import { isWindowDefined } from '@utils/validations';
import TemplateNotFound from '../TemplateNotFound';
import { FilterSelectionProp } from '@components/Templates/utils/constants';
import DesignList from '@ui/Design/DesignList';
import cn from '@utils/cn';
import { DesignSetIdLayout } from '@ui/Design/types';

type Props = {
  designSetLayout?: DesignSetIdLayout;
  initialTemplatesComp?: React.ReactElement;
  fetchedTemplates?: TemplatesQuery['templates'];
  initialTemplates?: TemplatesQuery['templates'];
  isGridView?: boolean;
  onSelectChange(filter?: FilterSelectionProp, pageNum?: number): void;
  selectedPage: number;
  elementRef?: React.RefObject<HTMLDivElement | null>;
  isStaticFilterSelected?: boolean;
  isRefetched: boolean;
  description?: string;
};

export default function Gallery({
  designSetLayout,
  fetchedTemplates,
  initialTemplates,
  isGridView,
  initialTemplatesComp,
  onSelectChange,
  selectedPage,
  elementRef,
  isStaticFilterSelected,
  isRefetched,
  description,
}: Props) {
  const isTemplateNotFound = !fetchedTemplates?.templates.length && !initialTemplates?.templates.length;

  function onClick(num: number) {
    if (elementRef && isWindowDefined) {
      const element = document.getElementById('notification-bar');
      const notificationbarHeight = element ? element.clientHeight : 0;

      window.scrollTo({
        top: (elementRef.current?.offsetTop ?? 0) - 80 - notificationbarHeight,
        behavior: 'smooth',
      });
    }
    onSelectChange(undefined, num);
  }

  function resetFilters() {
    onSelectChange({
      color: [],
      style: [],
      type: [],
      size: [],
      industry: [],
      page: '1',
    });
  }

  function DesignsView() {
    if (!isRefetched && initialTemplates?.templates.length) {
      return initialTemplatesComp;
    }

    if (fetchedTemplates?.templates.length) {
      return (
        <DesignList
          designSetLayout={designSetLayout}
          templates={fetchedTemplates.templates}
          isStaticFilterSelected={isStaticFilterSelected}
          isGrid={isGridView}
          description={description}
        />
      );
    }
    return <TemplateNotFound resetFilters={resetFilters} />;
  }

  return (
    <Container paddingType="horizontalOnly" childClassName={cn({ 'pt-4 md:pt-8': !isTemplateNotFound })}>
      <DesignsView />
      <NavBar
        totalCount={fetchedTemplates?.totalCount ?? initialTemplates?.totalCount}
        onClick={onClick}
        selectedPageNum={selectedPage}
      />
    </Container>
  );
}
